import Paper from 'components/Paper'

export const MultianchorSection = (): JSX.Element => {
  return <Paper sx={{ mt: 0 }}></Paper>
}
